module.exports = __webpack_public_path__ + "static/media/electro.8c745e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/electro.png
// module id = 476
// module chunks = 0